import { EXPLORER_TABS, type ExplorerTab } from "../../state/navigation";

interface TabBarProps {
  activeTab: ExplorerTab;
  onSelectTab: (tab: ExplorerTab) => void;
}

export default function TabBar({ activeTab, onSelectTab }: TabBarProps) {
  return (
    <div className="flex gap-1 border-b border-[var(--oe-border)] bg-[var(--oe-surface)] px-3">
      {EXPLORER_TABS.map((tab) => (
        <button
          key={tab.id}
          type="button"
          onClick={() => onSelectTab(tab.id)}
          className={`relative px-3.5 py-2.5 text-sm font-medium transition-colors ${
            activeTab === tab.id
              ? "text-[var(--oe-accent)]"
              : "text-[var(--oe-text-muted)] hover:text-[var(--oe-text)]"
          }`}
        >
          {tab.label}
          {activeTab === tab.id && (
            <span className="absolute inset-x-2 -bottom-px h-0.5 rounded-full bg-[var(--oe-accent)]" />
          )}
        </button>
      ))}
    </div>
  );
}
